module.exports = __webpack_public_path__ + "img/horse-portrait-painting-5.0578927a.png";